import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import { getEntityUrl } from '@culture/common-helpers/cultureUtils';
import { filterParticipants } from '@culture/utils/helpers/entities';
import { movieTypesHash } from '@culture/utils/helpers/movies';
import Icon from 'components/Icon';

import EntityCard from '../EntityCard';

import styles from './styles.module.scss';

const MovieCard = ({ data, orientation, ...props }) => {
	const {
		_id,
		title,
		thumbnailFile,
		thumbnailFileCrop,
		genres,
		year,
		duration,
		institute,
		tifloComments,
		participants,
		type,
		rubrics
	} = data;
	const movieOrientation =
		orientation ||
		(_([movieTypesHash.movie, movieTypesHash.performance]).contains(type)
			? 'portrait'
			: 'landscape');

	const movieDuration = duration && `${Math.ceil(duration / 60)} мин`;

	let movieAttributes = [];

	if (type === movieTypesHash.movie || type === movieTypesHash.performance) {
		const genreName = !_.isEmpty(genres) && genres[0].title.toLowerCase();

		movieAttributes = [genreName];
	} else if (type === movieTypesHash.lecture) {
		const lecturers = filterParticipants(participants, 'lecturer');

		if (lecturers.length) {
			movieAttributes = [_(lecturers).pluck('title').join(', ')];
		}
	}

	const linkHref = getEntityUrl('movies', data);
	const place = institute && {
		title: institute.title,
		url:
			institute.status === 'published'
				? getEntityUrl('institutes', institute)
				: null
	};

	const labels = [];
	const isOpenCollection = rubrics?.some(
		(rubric) => rubric.path === 'cinema/movies/open-collection'
	);

	if (tifloComments) {
		labels.push(
			<Icon icon="withTifloComments" className={styles.iconWithTifloComments} />
		);
	}

	if (isOpenCollection) {
		labels.push('ГФФ');
	}

	return (
		<EntityCard
			_id={_id}
			url={linkHref}
			title={title}
			image={thumbnailFile}
			subtitleItems={[...movieAttributes, year, movieDuration]}
			orientation={movieOrientation}
			place={place}
			labels={labels}
			themePlace="hide"
			theme="overlay"
			imageCrop={thumbnailFileCrop}
			{...props}
		/>
	);
};

MovieCard.propTypes = {
	data: PropTypes.shape({
		_id: PropTypes.number.isRequired,
		title: PropTypes.string.isRequired,
		thumbnailFile: PropTypes.object.isRequired,
		thumbnailFileCrop: PropTypes.object,
		duration: PropTypes.number,
		genres: PropTypes.arrayOf(
			PropTypes.shape({
				title: PropTypes.string
			})
		),
		year: PropTypes.number,
		tifloComments: PropTypes.bool,
		institute: PropTypes.object,
		type: PropTypes.oneOf(_.keys(movieTypesHash)).isRequired,
		participants: PropTypes.arrayOf(PropTypes.object),
		rubrics: PropTypes.arrayOf(
			PropTypes.shape({
				path: PropTypes.string
			})
		)
	}).isRequired,
	orientation: PropTypes.oneOf(['portrait', 'landscape'])
};

export default MovieCard;
